import { useEffect, useState } from "react";
import { PaginateObj } from "../../types/Paginate/PaginateObjt";
import { ItemRevisor } from "../../types/Revisor/ItemRevisor";
import { Box, Container, Grid, IconButton, Pagination, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@mui/material";
import { MdModeEdit } from "react-icons/md";
import { BsClockHistory } from "react-icons/bs";
import { themePalette } from "../../config/theme.config";
import { textDateFormat, textDateTimeFormat } from "../../utils/dateFormat";
import RevisorService from "../../services/RevisorService";
import { useNavigate } from "react-router-dom";

interface Props {
    page: PaginateObj<ItemRevisor>;
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

export const RevisorTable: React.FC<Props> = ({ page }) => {
    const navigate = useNavigate();
    const [iPage, setIpage] = useState<PaginateObj<ItemRevisor>>(page);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    // Function
    const fetchAnuncios = async () => {
        setLoading(true)
        try {
            if (iPage.totalPages > 1) {
                const response = await RevisorService.GetPageByNumber(iPage.firstPage, currentPage)
                const data = response;
                // console.log(data);
                if (response.succeeded) {
                    setIpage(data);
                }
            }
        } catch (error) {
            console.error(error)
        } finally {
            setLoading(false)
        }
    }
    const handleChangePage = (event: unknown, newPage: number) => {
        setCurrentPage(newPage); // Cambia la página
    };
    //Effect
    useEffect(() => {
        fetchAnuncios();
    }, [currentPage]);
    return (
        <Container maxWidth="lg" style={{ marginTop: 10, marginLeft: 20, padding: '20px', textAlign: 'center' }}>
            {iPage.data.length === 0
                ? (
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            textAlign: 'center', // Alinea el texto
                            backgroundColor: themePalette.BGWHITE, // Fondo claro
                        }}
                    >
                        <Typography variant="h4" color="primary">
                            Sin resultados
                        </Typography>
                    </Box>
                ) : (
                    <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                            {iPage.totalPages > 1 ? (
                                <Pagination
                                    count={iPage.totalPages} // Total de páginas
                                    page={currentPage} // Página actual
                                    onChange={handleChangePage} // Cambiar página
                                    color="primary"
                                    sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}
                                />
                            ) : (
                                <br />
                            )}
                        </Box>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>#</StyledTableCell>
                                        <StyledTableCell>Titulo</StyledTableCell>
                                        <StyledTableCell >Unidad</StyledTableCell>
                                        <StyledTableCell >Tipo</StyledTableCell>
                                        <StyledTableCell >Publicación</StyledTableCell>
                                        <StyledTableCell >Enviado</StyledTableCell>
                                        <StyledTableCell>Acción</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {iPage.data.map((row, index) => (
                                        <StyledTableRow key={row.idAnuncio}>
                                            <StyledTableCell component="th" scope="row">
                                                {index + (currentPage - 1) * 8 + 1}
                                            </StyledTableCell>
                                            <StyledTableCell>
                                                {row.txTitulo.length > 50 ? `${row.txTitulo.slice(0, 50)}...` : row.txTitulo}
                                            </StyledTableCell>
                                            <StyledTableCell>{row.unidad}</StyledTableCell>
                                            <StyledTableCell>{row.bdTipo === 'E' ? 'Evento' : 'Anuncio'}</StyledTableCell>
                                            <StyledTableCell>{textDateFormat(row.dtPublicacion)}</StyledTableCell>
                                            <StyledTableCell>{textDateTimeFormat(row.dtEnvio)}</StyledTableCell>
                                            <StyledTableCell>
                                                <Grid container spacing={1}>
                                                    <Grid item sm={6} >
                                                        <Tooltip title='Aprobar' placement='top' arrow>
                                                            <IconButton color="primary" onClick={() => navigate(`/reviewer/ver-aprobacion/${row.idAnuncio}`)}>
                                                                <MdModeEdit />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                    <Grid item sm={6} >
                                                        <Tooltip title='Historial' placement='top' arrow>
                                                            <IconButton color="secondary" onClick={() => navigate(`/reviewer/ver-historial/${row.idAnuncio}`)}>
                                                                <BsClockHistory />
                                                            </IconButton>
                                                        </Tooltip>
                                                    </Grid>
                                                </Grid>
                                            </StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                            {iPage.totalPages > 1 && (
                                <Pagination
                                    count={iPage.totalPages} // Total de páginas
                                    page={currentPage} // Página actual
                                    onChange={handleChangePage} // Cambiar página
                                    color="primary"
                                    sx={{ display: 'flex', justifyContent: 'center', padding: 2 }}
                                />
                            )}
                        </Box>
                    </Grid>
                )}
        </Container>
    )
}